/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Important_Pricing_PendingInputs */



/**
* | output |
* | --- |
* | "Pricing will be calculated based on file size." |
*
* @param {Embed_Captions_Important_Pricing_PendingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_important_pricing_pending = /** @type {((inputs?: Embed_Captions_Important_Pricing_PendingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Important_Pricing_PendingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le tarif sera calcule en fonction de la taille du fichier.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Preis wird anhand der Dateigröße berechnet.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il prezzo verrà calcolato in base alle dimensioni del file.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Стоимость будет рассчитываться исходя из размера файла.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El precio se calculará en función del tamaño del archivo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("价格将根据文件大小计算。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("価格はファイルサイズに基づいて計算されます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मूल्य निर्धारण फाइल के आकार के आधार पर किया जाएगा।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O preço será calculado com base no tamanho do arquivo.")
	return /** @type {LocalizedString} */ ("Pricing will be calculated based on file size.")
});